module.exports = __webpack_public_path__ + "static/media/integration.3aa6c73c.svg";